/**
 * Static Mermaid bundle — avoids deploy-sensitive lazy chunks (mermaid.core-*.js 404).
 */
import mermaid from "mermaid";

let initialized = false;
let renderCounter = 0;

function buildSingleColorThemeVariables(): Record<string, string> {
  const vars: Record<string, string> = {
    darkMode: "true",
    background: "#181818",
    primaryColor: "#304b73",
    primaryTextColor: "#e6ebf4",
    primaryBorderColor: "#5772a0",
    secondaryColor: "#304b73",
    secondaryBorderColor: "#5772a0",
    lineColor: "#7a83d8",
    textColor: "#e6ebf4",
    classText: "#e6ebf4",
    branchLabelColor: "#e6ebf4",
    scaleLabelColor: "#e6ebf4",
    fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
  };
  vars.cScale0 = "#6f3fb3";
  vars.cScaleLabel0 = "#f1e9ff";
  for (let i = 1; i < 12; i += 1) {
    vars[`cScale${i}`] = "#304b73";
    vars[`cScaleLabel${i}`] = "#e6ebf4";
  }
  return vars;
}

function ensureMermaidInitialized(): void {
  if (initialized) return;
  mermaid.initialize({
    startOnLoad: false,
    theme: "base",
    securityLevel: "loose",
    themeVariables: buildSingleColorThemeVariables(),
    mindmap: { padding: 16, maxNodeWidth: 220 },
  });
  initialized = true;
}

export async function renderMermaidToSvg(
  definition: string,
  idPrefix: string,
): Promise<string> {
  ensureMermaidInitialized();
  renderCounter += 1;
  const id = `${idPrefix}-${renderCounter}`;
  const { svg } = await mermaid.render(id, definition);
  return svg || "";
}
